import jss from 'jss';

const styles = {
  customer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    cursor: 'pointer',
    paddingLeft: 5,
    transition: 'all .3s',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    '&:hover': {
      background: 'rgba(0, 0, 0, 0.1)',
      color: 'black'
    }
  },
  location: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    paddingLeft: 45,
    cursor: 'pointer',
    transition: 'all .3s',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    '&:hover': {
      background: 'rgba(0, 0, 0, 0.1)',
      color: 'black'
    }
  },
  label: {
    marginLeft: 10,
    flex: 1
  },
  selected: {
    background: '#459dbf',
    color: 'white',
    '&:hover': {
      background: 'rgba(69, 157, 191, 0.8)',
      color: 'white',
    }
  },
  openToggleContainer: {
    minWidth: 20,
    minHeight: 20,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  openToggle: {

  }
};

export const { classes } = jss.createStyleSheet(styles).attach();


// WEBPACK FOOTER //
// ./src/views/customer/styles/tree.js